<template>
  <button v-if="type === 'featured'" class="hot-card featured-card" type="button" @click="$emit('click', game, 'featured')">
    <div class="featured-art">
      <img
        v-if="game.heroImage"
        :src="game.heroImage"
        :alt="game.name"
        class="featured-cover"
        fetchpriority="high"
        @error="game.heroImage = ''"
      />
      <div v-else class="featured-fallback">
        <span>{{ iconFallback(game) }}</span>
      </div>
      <div class="featured-gradient"></div>
      <div class="featured-footer">
        <span class="featured-icon-wrap">
          <span class="featured-icon">
            <img v-if="isUrlIcon(game.icon)" :src="game.icon" alt="" />
            <span v-else>{{ game.icon || '🎮' }}</span>
          </span>
        </span>
        <span class="featured-caption-text">
          <strong>{{ game.name }}</strong>
          <small>{{ game.shortDesc }}</small>
        </span>
        <span class="featured-instant">秒玩</span>
      </div>
    </div>
  </button>

  <div v-else class="hot-card secondary-frame">
    <span class="secondary-frame-title">
      <img src="/ui/zhuangshi_0027.webp" alt="" class="secondary-title-decoration" />
      <span>{{ group.heading }}</span>
    </span>
    <button
      v-for="item in group.items"
      :key="item.gameId"
      class="secondary-game"
      type="button"
      @click="$emit('click', item, 'secondary')"
    >
      <span class="secondary-icon-wrap">
        <span class="secondary-visual">
          <img v-if="isUrlIcon(item.icon)" :src="item.icon" :alt="item.name" class="secondary-cover" @error="item.icon = ''" />
          <img v-else-if="item.cardImage" :src="item.cardImage" :alt="item.name" class="secondary-cover" @error="item.cardImage = ''" />
          <span v-else class="secondary-fallback">
            <span>{{ item.icon || '🎮' }}</span>
          </span>
        </span>
        <span v-if="item.badge" class="secondary-tag" :style="tagStyle(item)">{{ item.badge }}</span>
      </span>
      <span class="secondary-copy">
        <strong>{{ item.name }}</strong>
        <small>{{ item.shortDesc }}</small>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'HotCard',
  props: {
    type: { type: String, required: true },
    game: { type: Object, default: null },
    group: { type: Object, default: null }
  },
  methods: {
    isUrlIcon(icon) {
      return icon && (/^https?:\/\//.test(icon) || /^\/(mygames\/)?uploads\//.test(icon) || /^\/ui\//.test(icon))
    },
    iconFallback(game) {
      return this.isUrlIcon(game.icon) ? '🎮' : (game.icon || '🎮')
    },
    tagStyle(game) {
      return game && game.tagColor ? { backgroundColor: game.tagColor } : {}
    }
  }
}
</script>

<style scoped>
.hot-card {
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  border-radius: 16px;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  box-shadow:
    0 2px 5px rgba(25, 76, 135, 0.12),
    0 8px 18px rgba(25, 76, 135, 0.18);
}
.hot-card:active { transform: scale(0.98); }

.featured-card {
  display: block;
  padding: 0;
  cursor: pointer;
  border: 3px solid #fff;
}

.featured-art { position: relative; width: 100%; aspect-ratio: 0.78 / 1; overflow: hidden; background: linear-gradient(160deg, #5b6b9e, #2b3568); }
.featured-cover { display: block; width: 100%; height: 100%; object-fit: cover; }
.featured-fallback { display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; color: #fff; }
.featured-fallback span { font-size: clamp(3rem, 12vw, 5rem); }
.featured-gradient { position: absolute; right: 0; bottom: 0; left: 0; height: 42%; background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.24) 45%, rgba(0, 0, 0, 0.82) 100%); pointer-events: none; }

.featured-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: grid;
  grid-template-areas:
    "icon icon"
    "caption action";
  grid-template-columns: minmax(0, 1fr) auto;
  row-gap: 6px;
  align-items: end;
  padding: 10px;
  background: transparent;
}
.featured-icon-wrap { position: relative; flex-shrink: 0; grid-area: icon; }
.featured-icon { display: flex; width: 48px; height: 48px; align-items: center; justify-content: center; overflow: hidden; border: 2px solid #fff; border-radius: 11px; background: #eef2f8; font-size: 1.6rem; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24); }
.featured-icon img { width: 100%; height: 100%; object-fit: cover; }
.featured-caption-text { min-width: 0; text-align: left; grid-area: caption; }
.featured-caption-text strong { display: block; overflow: hidden; color: #fff; font-size: 17px; font-weight: 700; text-overflow: ellipsis; white-space: nowrap; }
.featured-caption-text small { display: block; margin-top: 4px; overflow: hidden; color: rgba(255, 255, 255, 0.84); font-size: 14px; text-overflow: ellipsis; white-space: nowrap; }
.featured-instant { flex-shrink: 0; grid-area: action; align-self: end; padding: 5px 13px; color: #2F8CFF; font-size: 13px; font-weight: 700; line-height: 1.2; border: 1px solid rgba(255, 255, 255, 0.95); border-radius: 999px; background: #fff; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); }

.secondary-frame {
  box-sizing: border-box;
  height: auto;
  min-height: 0;
  padding: 14px 12px 12px;
  border: 1px solid rgba(255, 255, 255, 0.88);
  background: #fff;
  box-shadow:
    0 2px 5px rgba(25, 76, 135, 0.12),
    0 8px 18px rgba(25, 76, 135, 0.18);
}

.secondary-frame-title {
  display: flex;
  flex: 0 0 30px;
  overflow: hidden;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: #2F8CFF;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1px;
  line-height: 1.25;
  white-space: nowrap;
}
.secondary-frame-title > span { overflow: hidden; text-overflow: ellipsis; }
.secondary-title-decoration { display: block; flex: 0 0 6px; width: 6px; height: 28px; object-fit: fill; }

.secondary-game {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 68px;
  align-items: center;
  gap: 10px;
  padding: 0;
  text-align: left;
  cursor: pointer;
  transition: transform 0.16s ease;
}
.secondary-game:not(:last-child) { margin-bottom: 8px; }
.secondary-game:active { transform: scale(0.96); }
.secondary-icon-wrap { display: block; position: relative; flex: 0 0 56px; }
.secondary-visual { display: block; width: 56px; height: 56px; overflow: hidden; border: 2px solid #fff; border-radius: 12px; background: #eef2f8; box-shadow: 0 4px 10px rgba(16, 54, 104, 0.38), 0 0 0 2px rgba(47, 140, 255, 0.2), inset 0 0 0 1px rgba(255, 255, 255, 0.55); }
.secondary-cover { display: block; width: 100%; height: 100%; object-fit: cover; }
.secondary-fallback { display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; font-size: 1.4rem; background: #eef2f8; }
.secondary-fallback img { width: 60%; height: 60%; border-radius: 20%; object-fit: cover; }
.secondary-tag { position: absolute; top: -5px; right: -8px; padding: 2px 7px; color: #fff; font-size: 9px; font-weight: 700; letter-spacing: 1px; border: 1px solid #fff; border-radius: 999px; background: #2F8CFF; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2); }
.secondary-copy { flex: 1; display: flex; min-width: 0; flex-direction: column; justify-content: center; }
.secondary-copy strong { display: block; overflow: hidden; color: #111; font-size: clamp(11px, 3.8vw, 14px); font-weight: 800; letter-spacing: 0; line-height: 1.25; text-overflow: ellipsis; white-space: nowrap; }
.secondary-copy small { margin-top: 6px; overflow: hidden; color: #999; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }

@media (prefers-reduced-motion: reduce) {
  .hot-card, .secondary-game { transition: none; }
}
</style>
